import React, { useEffect } from "react";
import { Paper, TableContainer } from "@mui/material";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import style from "./PortfolioTabNavigation.module.css";
import { useApi } from "../../../../../common/hooks";
import { PortfolioSearchService } from "../../../../../api";
import PortfolioTabSearch from "./PortfolioTabSearch";
import TableSearchContent from "./table-search/TableSearchContent";
import LoadingOverlay from "../../../../../common/components/loaders/LoadingOverlay";
import { preparePayload } from "../utils/utils";
import {
	resetAllFiltersPortfolioSpace,
	setRowsPerPage,
	setTableBody,
	setTableHead,
} from "../slice/portfolio-space-slice";

export function PortfolioTabPanel({ page }) {
	const { call: getPortfoliosSearchById } = useApi(PortfolioSearchService.getPortfoliosSearchById);
	const { call: getMyPortfoliosFilters } = useApi(PortfolioSearchService.getMyPortfoliosFilters);
	const { rowsPerPage, tableBody, sorting, filters } = useSelector(
		({ portfolioSpace }) => ({
			rowsPerPage: portfolioSpace?.rowsPerPage,
			tableBody: portfolioSpace?.tableBody,
			sorting: portfolioSpace?.sorting,
			filters: portfolioSpace?.filters,
		}),
		shallowEqual
	);
	const [pageDataTable, setPageDataTable] = React.useState(0);
	const [isLoading, setIsLoading] = React.useState(false);
	const dispatch = useDispatch();
	const getHeadTable = (customPageId) => {
		getMyPortfoliosFilters(customPageId)
			.then((data) => {
				dispatch(setTableHead(data));
			})
			.catch(console.error);
	};
	const getBodyTable = (params) => {
		setIsLoading(true);
		getPortfoliosSearchById(params)
			.then((data) => {
				dispatch(setTableBody(data));
				setIsLoading(false);
			})
			.catch((e) => {
				console.error(e);
				setIsLoading(false);
			});
	};

	const handleChangePage = (newPage) => {
		setPageDataTable(newPage);
		if (page?.id) {
			const customPageId = page.id;
			const payload = preparePayload(filters, sorting);
			const params = {
				page: newPage,
				limit: rowsPerPage,
				portfolioId: customPageId,
				payload,
			};
			getBodyTable(params);
		}
	};

	const handleChangeRowsPerPage = (newRowsPerPage) => {
		dispatch(setRowsPerPage(+newRowsPerPage));
		setPageDataTable(0);
		if (page?.id) {
			const customPageId = page.id;
			const payload = preparePayload(filters, sorting);
			const params = { page: 0, limit: newRowsPerPage, portfolioId: customPageId, payload };
			getBodyTable(params);
		}
	};
	useEffect(
		() => () => {
			dispatch(resetAllFiltersPortfolioSpace({}));
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	useEffect(() => {
		if (page?.id) {
			const customPageId = page.id;
			setPageDataTable(0);
			getHeadTable(customPageId);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page?.id]);

	useEffect(() => {
		const payload = preparePayload(filters, sorting);
		setPageDataTable(0);
		const params = {
			page: 0,
			limit: rowsPerPage,
			portfolioId: page.id,
			payload,
		};
		getBodyTable(params);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filters, sorting]);
	return (
		<div className={style.tabNavigationPanelContainer}>
			{isLoading && <LoadingOverlay />}
			<PortfolioTabSearch />
			<Paper className={style.tabNavigationPaper} elevation={0}>
				<TableContainer className={style.tableContainer}>
					<TableSearchContent
						currentPage={pageDataTable}
						rowsPerPage={rowsPerPage}
						totalElements={tableBody?.totalElements}
						onPageChange={handleChangePage}
						onRowsPerPageChange={handleChangeRowsPerPage}
					/>
				</TableContainer>
			</Paper>
		</div>
	);
}
